export const updateOwnProfile = () => ({
  updatePerson: {
    id: 'sdo-mdfonjmasd-nmdgvpndpvn2135-35m-95smso',
    nativeGivenName: 'UNKNOWN',
    nativeFamilyName: 'Testington',
    birthDate: '1990-07-20',
    age: 31,
    birthYear: 0,
    tennisID: 'FIL123456',
    nationalID: '',
    sex: 'M',
    nationalityCode: 'ITA',
    optedOutOfPublicDataConsent: false,
    biographicalInformation: {
      placeOfResidence: 'GBR',
      playingHand: '',
      doublePlayingHand: '',
      weightInKgs: 79.2,
      heightInMeters: 1.79,
      avatarUrl: '',
      favouriteShot: '',
      __typename: 'BiographicalInformation',
    },
    worldTennisNumbers: [
      {
        type: 'DOUBLE',
        tennisNumber: 24.81,
        confidence: 0.6,
        __typename: 'WorldTennisNumber',
      },
      {
        type: 'SINGLE',
        tennisNumber: 24.02,
        confidence: 0.7,
        __typename: 'WorldTennisNumber',
      },
    ],
    __typename: 'Person',
  },
})
